<template>
  <div class="step-select">
    <slot
      v-if="product"
      name="product-thumbnail"
      :product="productData"
      :url-template="localImageSrc"
      :updateUpcId="handleUpdateUpcId"
    />
    <div
      v-if="!isAddToWishlistSuccess"
      class="error-message-wrap"
    >
      <Notification
        severity="error"
        :closable="false"
      >
        Sorry, we’re unable to add this to your Wish List at
        this time.
      </Notification>
    </div>
    <div class="button-wrap">
      <button
        class="button primary expanded"
        :disabled="!selectedProduct"
        @click="handleAddToWishList"
      >
        add to wish list
      </button>
      <button
        class="button secondary expanded"
        @click="() => toggle('wishlistDrawer')"
      >
        continue shopping
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Notification from '@atomic-ui/notification';
import { addToWishList } from '../services/api';
import colorObjectToArray from '../utils/productTransformers';

export default {
  name: 'StepSelect',
  components: { Notification },
  props: {
    product: {
      type: Object,
      default: undefined,
    },
  },
  emits: ['addToWishListSuccess', 'addToWishListError'],
  data() {
    return {
      selectedProduct: null,
      productData: { ...this.product },
      isAddToWishlistSuccess: true,
    };
  },
  computed: {
    localImageSrc() {
      return this.productData.urlTemplate;
    },
  },
  beforeMount() {
    this.productData = colorObjectToArray(this.product);
  },
  methods: {
    ...mapMutations({
      toggle: 'slideoutStore/TOGGLE',
    }),
    handleUpdateUpcId(selectedProduct) {
      this.selectedProduct = selectedProduct;
    },
    handleAddToWishList() {
      addToWishList(
        this.selectedProduct.upcId,
        (response) => this.$emit('addToWishListSuccess', { product: this.selectedProduct, response }),
        () => { this.isAddToWishlistSuccess = false; },
      );
    },
  },
};
</script>
<style lang="scss" brand="bcom" scoped>
.step-select {
  :deep(.product-thumbnail-container) {
    .product-description {
      display: none;
    }

    .color-and-size-container {
      .colors:after {
        content: "";
        display: table;
        clear: both;
      }
    }
  }

  .error-message-wrap {
    margin-bottom: rem-calc(20);
  }
}
</style>
